import { UserPersonalCabinet } from './ui/UserPersonalCabinet'
export default UserPersonalCabinet